module.exports = __webpack_public_path__ + "img/index_pic3.b657760b.png";